import { z } from 'zod'

import type { PlantAssessment } from '@/features/assessments/api/assessment-list'

export const assessmentFormSchema = z.object({
  plantName: z.string().min(1, 'Plant name is required'),
  country: z.string().min(1, 'Country is required'),
  // Nullable, not optional: a clearable field must never resolve back to
  // `undefined`, which react-hook-form's useWatch treats as "fall back to the
  // value the field mounted with" — the cleared owner would reappear.
  dealOwnerUserID: z.string().nullable(),
  salesEngineerUserID: z.string().nullable(),
  isAtex: z.boolean(),
  hubspotDealId: z.string().nullable(),
  hubspotPlantId: z.string().trim().nullable(),
  assessedAt: z.string().nullable().optional(),
  lastOnsiteAt: z.string().nullable().optional()
})

export type AssessmentFormValues = z.infer<typeof assessmentFormSchema>

export const EMPTY_ASSESSMENT_FORM_VALUES: AssessmentFormValues = {
  plantName: '',
  country: '',
  dealOwnerUserID: null,
  salesEngineerUserID: null,
  isAtex: false,
  hubspotDealId: null,
  hubspotPlantId: null,
  assessedAt: undefined,
  lastOnsiteAt: undefined
}

export function getAssessmentFormDefaultValues(
  mode: 'create' | 'edit',
  assessment: PlantAssessment | undefined
): AssessmentFormValues {
  if (mode === 'edit' && assessment) {
    return {
      plantName: assessment.plantName,
      country: assessment.country,
      dealOwnerUserID: assessment.dealOwnerUserID ?? null,
      salesEngineerUserID: assessment.salesEngineerUserID ?? null,
      isAtex: assessment.isAtex,
      hubspotDealId: assessment.hubspotDealId ?? null,
      hubspotPlantId: assessment.hubspotPlantId ?? null,
      assessedAt: assessment.assessedAt ? assessment.assessedAt.slice(0, 10) : null,
      lastOnsiteAt: assessment.lastOnsiteAt ? assessment.lastOnsiteAt.slice(0, 10) : null
    }
  }
  return EMPTY_ASSESSMENT_FORM_VALUES
}
